export const createSignalPromise = (signal?: AbortSignal) =>
    new Promise((_, reject) =>
        signal?.addEventListener('abort', () => reject())
    );
